import React, { Fragment, useEffect } from "react";

import "../../../assets/css/HomeSocial.scss";

const LIGHTWIDGET_SCRIPT_SRC =
  "https://cdn.lightwidget.com/widgets/lightwidget.js";
const LIGHTWIDGET_IFRAME_SRC =
  "https://cdn.lightwidget.com/widgets/49f9f59c452b593f9ccbda97afe1490b.html";

const HomeSocial = () => {
  useEffect(() => {
    const existingScript = document.querySelector(
      `script[src="${LIGHTWIDGET_SCRIPT_SRC}"]`
    );

    if (existingScript) {
      return undefined;
    }

    const script = document.createElement("script");
    script.src = LIGHTWIDGET_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <Fragment>
      <div className="socialImages">
        <div className="head-ins-part">
          <h2>Follow us @ddecorrugs</h2>
        </div>

        <div className="lightwidget-wrapper">
          <iframe
            title="D'Decor Rugs Instagram feed"
            src={LIGHTWIDGET_IFRAME_SRC}
            scrolling="no"
            allowTransparency={true}
            className="lightwidget-widget"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default HomeSocial;
